import { ImageType } from './files';

export enum PromotionType {
  GeneralPromotion = 1,
  DeliveryFee = 2,
}

export enum DiscountType {
  Fixed = 1,
  Percentage = 2,
}

export interface Promotion {
  id: number;
  name_en: string;
  name_ar: string;
  image_id: number;
  image: ImageType;
  promotion_type: number;
  promotion_type_name: string;
  discount_type: number;
  discount_type_name: string;
  discount_value: string;
  silal_contribution_percentage: string;
  store_contribution_percentage: string;
  store_ids: number[];
  disabled: boolean;
  is_active_now: boolean;
  created_at: string;
  start_date: string;
  end_date: string;
  is_delivery_discount: boolean;
  requires_coupon: boolean;
  min_order_value: string;
  max_discount_amount?: number;
  coupons: Coupon[];
}

export interface Coupon {
  id: number;
  code: string;
  promotion_id: number;
  created_at: string;
  max_uses: number;
  disabled: boolean;
  used_times: number;
  max_uses_per_user: number;
}
